import React from 'react'
import CreatePackage from '../../myComponents/CreatePackage'

const CreateSubscriptionPackage = () => {
  return (
   <CreatePackage/>
  )
}

export default CreateSubscriptionPackage
